/**
 * Galleridata og alt-tekster for Tømrermester Daniel Vandet.
 * Indeholder alle billeder fra projektets assets inddelt efter fagområder/undersider.
 */

export const CDN_BASE = 'https://assets.auxodev.dk/assets/cf6a3489-9db0-408d-9584-8086b110e180/'

// Specifikke billeder til hver underside med skræddersyede alt-tekster og titler
export const GALLERY_BY_KEY = {
  'vinduer-og-doere': [
    {
      url: `${CDN_BASE}nye-terrasse-doere.jpg`,
      alt: 'Montering af nye terrassedøre med store glaspartier og flot lysindfald - Tømrermester Daniel Vandet',
      title: 'Nye terrassedøre'
    },
    {
      url: `${CDN_BASE}ny-doer.jpg`,
      alt: 'Montering af ny yderdør med glasfelt i bolig på Mors - Tømrermester Daniel Vandet',
      title: 'Ny facadedør med glasfelt'
    },
    {
      url: `${CDN_BASE}ny-hvid-doer.jpg`,
      alt: 'Ny hvid facadedør med klassiske sprosser monteret i murstenshus - Tømrermester Daniel Vandet',
      title: 'Hvid facadedør med sprosser'
    },
    {
      url: `${CDN_BASE}ny-doer-og-vindue_10f9bc0e.jpg`,
      alt: 'Udskiftning af facadeparti med ny yderdør og tilhørende sidevindue - Tømrermester Daniel Vandet',
      title: 'Nyt indgangsparti'
    },
    {
      url: `${CDN_BASE}udskiftning-af-vinduer-og-doere_fb146f98.jpg`,
      alt: 'Komplet udskiftning af ældre vinduer og døre til energirigtige løsninger - Tømrermester Daniel Vandet',
      title: 'Total udskiftning af vinduer og døre'
    },
    {
      url: `${CDN_BASE}ny-doer-indenfor.jpg`,
      alt: 'Montering af ny indvendig dør med gerigter og karm - Tømrermester Daniel Vandet',
      title: 'Ny indvendig dør'
    },
    {
      url: `${CDN_BASE}roede-vinduer.jpg`,
      alt: 'Nye røde træ-alu vinduer monteret med respekt for husets oprindelige arkitektur - Tømrermester Daniel Vandet',
      title: 'Klassiske røde vinduer'
    },
    {
      url: `${CDN_BASE}nye-sorte-vinduer.jpg`,
      alt: 'Nye moderne sorte sprossevinduer monteret med præcise fuger - Tømrermester Daniel Vandet',
      title: 'Moderne sorte vinduer'
    },
    {
      url: `${CDN_BASE}nyt-vindue.jpg`,
      alt: 'Nyt energivenligt vindue monteret af Tømrermester Daniel Vandet',
      title: 'Energirigtigt vindue'
    },
    {
      url: `${CDN_BASE}ny-doer-og-vindue.jpg`,
      alt: 'Nymonteret yderdør og vindueselement med flot finish - Tømrermester Daniel Vandet',
      title: 'Dør- og vinduesparti'
    },
    {
      url: `${CDN_BASE}udskiftning-af-vindue.jpg`,
      alt: 'Udskiftning af ældre vindue til nyt lavenergivindue - Tømrermester Daniel Vandet',
      title: 'Vinduesudskiftning'
    },
    {
      url: `${CDN_BASE}lille-vindue.jpg`,
      alt: 'Montering af mindre vindue med præcis tilpasning i murværk - Tømrermester Daniel Vandet',
      title: 'Præcist tilpasset vindue'
    },
    {
      url: `${CDN_BASE}nye-vinduer.jpg`,
      alt: 'Udskiftning til nye hvide sprossevinduer i villa - Tømrermester Daniel Vandet',
      title: 'Nye sprossevinduer'
    },
    {
      url: `${CDN_BASE}nymonterede-vinduer.jpg`,
      alt: 'Færdigt resultat med nymonterede vinduer og tæt isolering - Tømrermester Daniel Vandet',
      title: 'Færdigmonterede vinduer'
    },
    {
      url: `${CDN_BASE}udskiftning-af-vinduer-og-doere.jpg`,
      alt: 'Nye energirigtige vinduer og døre monteret af fagmand på Mors - Tømrermester Daniel Vandet',
      title: 'Vinduer og døre udskiftet'
    },
    {
      url: `${CDN_BASE}nye-vinduespartier-forskellig-stoerrelser.jpg`,
      alt: 'Flotte nye vinduespartier i forskellige formater tilpasset huset - Tømrermester Daniel Vandet',
      title: 'Vinduespartier i varierede mål'
    },
    {
      url: `${CDN_BASE}nye-roede-vinduer.jpg`,
      alt: 'Nymonterede klassiske røde vinduer med sprosser - Tømrermester Daniel Vandet',
      title: 'Røde sprossevinduer'
    },
    {
      url: `${CDN_BASE}f4b9946e-04f1-4da1-898f-5577a68d2355.jpeg`,
      alt: 'Montering af nye vinduer i gavl - Tømrermester Daniel Vandet',
      title: 'Gavlvinduer'
    },
    {
      url: `${CDN_BASE}f5cad2a3-1778-4d66-8705-2b2400cd6752.jpeg`,
      alt: 'Nye vindueselementer monteret i facade - Tømrermester Daniel Vandet',
      title: 'Facadeelementer'
    },
    {
      url: `${CDN_BASE}04928c09-d0a5-4a4c-a344-081a5a7eb555.jpeg`,
      alt: 'Færdigmonteret terrassedør og vindue mod have - Tømrermester Daniel Vandet',
      title: 'Terrassedør og vindue'
    },
    {
      url: `${CDN_BASE}24355f85-3a8b-48c7-978c-d6baa1e6ea24.jpeg`,
      alt: 'Udskiftning af vinduesparti mod have med optimal lysgennemgang - Tømrermester Daniel Vandet',
      title: 'Stort vinduesparti'
    },
    {
      url: `${CDN_BASE}1df48455-8075-4a04-a98b-1b9e74e5d2c8.jpeg`,
      alt: 'Nyt stort vinduesparti med optimal isoleringsevne - Tømrermester Daniel Vandet',
      title: 'Stort glasparti'
    },
    {
      url: `${CDN_BASE}b760aca1-d014-43fa-b13d-cbcdd28a1598.jpeg`,
      alt: 'Flot afslutning omkring nymonteret vindue - Tømrermester Daniel Vandet',
      title: 'Vinduesfinish'
    }
  ],

  'traeterasse': [
    {
      url: `${CDN_BASE}ny-traeterrasse-mors.jpg`,
      alt: 'Opbygning af ny stor træterrasse på Mors med smukke detaljer - Tømrermester Daniel Vandet',
      title: 'Ny træterrasse på Mors'
    },
    {
      url: `${CDN_BASE}ny-traeterrasse-ved-hegn.jpg`,
      alt: 'Ny træterrasse integreret med læhegn for ugeneret udeliv - Tømrermester Daniel Vandet',
      title: 'Træterrasse med integreret læhegn'
    },
    {
      url: `${CDN_BASE}ny-terrasse.jpg`,
      alt: 'Nyanlagt træterrasse med præcise skæringer og skjulte skruer - Tømrermester Daniel Vandet',
      title: 'Nyanlagt træterrasse'
    },
    {
      url: `${CDN_BASE}traeterrasse-til-sommerhus.jpg`,
      alt: 'Skræddersyet træterrasse opført til sommerhus i rolige naturomgivelser - Tømrermester Daniel Vandet',
      title: 'Sommerhusterrasse i træ'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-trapper.jpg`,
      alt: 'Hævet træterrasse med bred trappeovergang til haven - Tømrermester Daniel Vandet',
      title: 'Hævet terrasse med trappeløsning'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-hegn-og-trapper.jpg`,
      alt: 'Hævet terrasse med integreret gelænder, afskærmning og trappetrin - Tømrermester Daniel Vandet',
      title: 'Hævet terrasse med gelænder og trappe'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse.jpg`,
      alt: 'Solid hævet træterrasse på stabilt fundament - Tømrermester Daniel Vandet',
      title: 'Hævet terrassekonstruktion'
    },
    {
      url: `${CDN_BASE}traeterrasse.jpg`,
      alt: 'Kvalitetsbygget træterrasse med smukke holdbare terrassebrædder - Tømrermester Daniel Vandet',
      title: 'Træterrasse i høj kvalitet'
    },
    {
      url: `${CDN_BASE}traeterrasse-med-hegn.jpg`,
      alt: 'Træterrasse med matchende læhegn og lækkert finish - Tømrermester Daniel Vandet',
      title: 'Træterrasse og læhegn'
    },
    {
      url: `${CDN_BASE}bc0795d7-8d9d-4b61-8a7b-3bc771000587.jpeg`,
      alt: 'Stor terrasse i træ med udsigt over haven - Tømrermester Daniel Vandet',
      title: 'Rummelig træterrasse'
    },
    {
      url: `${CDN_BASE}2e8b03d9-d075-4746-96cb-4610a3b095df.jpeg`,
      alt: 'Træterrasse med trappeovergang og niveaudeling - Tømrermester Daniel Vandet',
      title: 'Niveauopdelt terrasse'
    },
    {
      url: `${CDN_BASE}32945422-2685-43f7-a9ff-7ce48ca0cba1.jpeg`,
      alt: 'Terrassekonstruktion med solide strøer og understøtning - Tømrermester Daniel Vandet',
      title: 'Opbygning af underkonstruktion'
    },
    {
      url: `${CDN_BASE}2c7e740e-8a67-4a12-ba8a-d3096131d6f2.jpeg`,
      alt: 'Nylagt terrassebelægning i holdbart kvalitetstræ - Tømrermester Daniel Vandet',
      title: 'Terrassebelægning i træ'
    },
    {
      url: `${CDN_BASE}a0599b3e-cd66-46de-a607-9b13dadff7cf.jpeg`,
      alt: 'Træterrasse ved sommerhus i smukke omgivelser - Tømrermester Daniel Vandet',
      title: 'Terrasse ved sommerhus'
    },
    {
      url: `${CDN_BASE}ad9dcb61-a734-4b91-8fd3-0eb1c034da0b.jpeg`,
      alt: 'Terrasseprojekt udført med sans for detaljen og lige linjer - Tømrermester Daniel Vandet',
      title: 'Detaljearbejde på træterrasse'
    },
    {
      url: `${CDN_BASE}8b9d0280-beac-47fd-9bf4-62d53009c3be.jpeg`,
      alt: 'Flot hjørneløsning og kantafslutning på ny træterrasse - Tømrermester Daniel Vandet',
      title: 'Hjørne- og kantafslutning'
    },
    {
      url: `${CDN_BASE}e369d168-b02e-4e05-9799-724a51675051.jpeg`,
      alt: 'Træterrasse der skaber et indbydende uderum - Tømrermester Daniel Vandet',
      title: 'Indbydende uderum i haven'
    },
    {
      url: `${CDN_BASE}9501042a-ef10-4fca-a168-c05d98e8e183.jpeg`,
      alt: 'Terrasse i trykimprægneret træ med lang holdbarhed - Tømrermester Daniel Vandet',
      title: 'Langtidsholdbar terrasse'
    },
    {
      url: `${CDN_BASE}936c4436-cab7-4335-8526-102d1038420b.jpeg`,
      alt: 'Udført terrasseprojekt med integrerede trin - Tømrermester Daniel Vandet',
      title: 'Terrasse med integrerede trin'
    },
    {
      url: `${CDN_BASE}d5b196fa-b993-4e29-88ef-d45cd4ef4324.jpeg`,
      alt: 'Træterrasse afsluttet med pæne kanter og lister - Tømrermester Daniel Vandet',
      title: 'Flot finish og lister'
    },
    {
      url: `${CDN_BASE}4b488ec8-4810-4bcb-9bd1-53b4bf1218b0.jpeg`,
      alt: 'Sommerhusterrasse bygget af Tømrermester Daniel Vandet',
      title: 'Terrasse ved sommerhusfacade'
    }
  ],

  'hegn-og-stakit': [
    {
      url: `${CDN_BASE}opsaetning-af-nyt-hegn.jpg`,
      alt: 'Opsætning af nyt læhegn i træ i haven på Mors - Tømrermester Daniel Vandet',
      title: 'Nyt læhegn i træ'
    },
    {
      url: `${CDN_BASE}hegnopsaetning.jpg`,
      alt: 'Professionel hegnopsætning i have med lige linjer og solid forankring - Tømrermester Daniel Vandet',
      title: 'Solid hegnopsætning'
    },
    {
      url: `${CDN_BASE}moerk-komposithegn.jpg`,
      alt: 'Mørkt komposithegn eller plankeværk opsat for optimalt privatliv og læ - Tømrermester Daniel Vandet',
      title: 'Mørkt hegn for privatliv'
    },
    {
      url: `${CDN_BASE}e6b9e57f-9f9d-4dc6-a8b3-de51658094e6.jpeg`,
      alt: 'Opsætning af vandret beklædt hegn ved terrasse - Tømrermester Daniel Vandet',
      title: 'Vandret beklædt læhegn'
    },
    {
      url: `${CDN_BASE}7f156cfc-c5cc-4564-82c8-509433795aa5.jpeg`,
      alt: 'Hegn ved terrasse og indkørsel med flot afslutning - Tømrermester Daniel Vandet',
      title: 'Afskærmende havehegn'
    },
    {
      url: `${CDN_BASE}0875081a-31c3-4bfc-a726-feae74cb75f8.jpeg`,
      alt: 'Stakit med solide stolper og pæne afslutninger - Tømrermester Daniel Vandet',
      title: 'Stakit med stolpefundament'
    },
    {
      url: `${CDN_BASE}6e67c1fd-9ae4-44b2-955b-7609a071a196.jpeg`,
      alt: 'Skræddersyet træhegn i haven tilpasset grundens terræn - Tømrermester Daniel Vandet',
      title: 'Terræntilpasset hegn'
    },
    {
      url: `${CDN_BASE}97a2c994-b2f5-40cd-8b55-b5d2969c474a.jpeg`,
      alt: 'Læhegn ved terrasse med høj stabilitet mod vestenvind - Tømrermester Daniel Vandet',
      title: 'Stabilt læhegn'
    },
    {
      url: `${CDN_BASE}54da0118-4c19-4987-8985-1db3e5905588.jpeg`,
      alt: 'Hegnopsætning på Mors udført i slidstærkt træ - Tømrermester Daniel Vandet',
      title: 'Hegn i holdbart træ'
    },
    {
      url: `${CDN_BASE}742fbda2-6bb6-441c-80c7-38f76ab16c11.jpeg`,
      alt: 'Træhegn opført i god håndværksmæssig kvalitet - Tømrermester Daniel Vandet',
      title: 'Klassisk træhegn'
    },
    {
      url: `${CDN_BASE}369d0f84-80a8-4853-849c-ad617bece750.jpeg`,
      alt: 'Solidt havehegn der giver læ for vinden - Tømrermester Daniel Vandet',
      title: 'Vindafskærmning i haven'
    },
    {
      url: `${CDN_BASE}575e38aa-a4a0-47f2-9ec3-ad6165793c0a.jpeg`,
      alt: 'Flot plankeværk med præcis tilpasning og lige linjer - Tømrermester Daniel Vandet',
      title: 'Plankeværk i haven'
    },
    {
      url: `${CDN_BASE}b15ba32e-cced-4cb9-ba86-3b75fe0f175e.jpeg`,
      alt: 'Opsætning af hegn omkring have og terrasseområde - Tømrermester Daniel Vandet',
      title: 'Have- og terrassehegn'
    },
    {
      url: `${CDN_BASE}61eb5aac-174c-4364-9007-1685243b40e7.jpeg`,
      alt: 'Færdigt hegnsprojekt udført af Tømrermester Daniel Vandet',
      title: 'Færdigt hegnsprojekt'
    }
  ],

  'gulve-og-lofte': [
    {
      url: `${CDN_BASE}nyt-loft.jpg`,
      alt: 'Montering af nyt rustikloft og træloft med pæne overgange og lister - Tømrermester Daniel Vandet',
      title: 'Montering af nyt loft'
    },
    {
      url: `${CDN_BASE}f826fd90-fc43-4d08-8965-f7b430dcc969.jpeg`,
      alt: 'Lægning af nyt trægulv med præcise samlinger - Tømrermester Daniel Vandet',
      title: 'Lægning af nyt trægulv'
    },
    {
      url: `${CDN_BASE}8adde98a-69d4-42ac-9481-189da96e432e.jpeg`,
      alt: 'Nylagt plankegulv i stue med plan overflade - Tømrermester Daniel Vandet',
      title: 'Nylagt plankegulv'
    },
    {
      url: `${CDN_BASE}d539f46d-3ae8-46ed-9a27-c93083ea0dca.jpeg`,
      alt: 'Lægning af kvalitetsgulv med smukke detaljer - Tømrermester Daniel Vandet',
      title: 'Kvalitetsgulv i bolig'
    },
    {
      url: `${CDN_BASE}94ed37ad-9cd0-4331-9ea1-47f375fb5aa4.jpeg`,
      alt: 'Flot gulvarbejde med tilskårne fodlister og tætte samlinger - Tømrermester Daniel Vandet',
      title: 'Gulvarbejde og fodlister'
    },
    {
      url: `${CDN_BASE}0610b674-8370-4c2f-a965-615e0b051def.jpeg`,
      alt: 'Gulvlægning udført i renoveret bolig på Mors - Tømrermester Daniel Vandet',
      title: 'Gulvlægning i renovering'
    },
    {
      url: `${CDN_BASE}ccc07cee-7e77-4e1f-b7f4-218e75c87c06.jpeg`,
      alt: 'Nyt gulv monteret med plan underlagskonstruktion - Tømrermester Daniel Vandet',
      title: 'Nyt gulv på plant underlag'
    },
    {
      url: `${CDN_BASE}e9a998be-08ac-40d3-87a5-8ff6e6562b55.jpeg`,
      alt: 'Kvalitetsgulv lagt i villa med optimal lyddæmpning - Tømrermester Daniel Vandet',
      title: 'Slidstærkt boliggulv'
    },
    {
      url: `${CDN_BASE}8097af19-69f4-4dd9-8e31-b88d1b30a2ec.jpeg`,
      alt: 'Lægning af slidstærkt gulv med jævnt forløb - Tømrermester Daniel Vandet',
      title: 'Jævnt og slidstærkt gulv'
    },
    {
      url: `${CDN_BASE}625334ac-e74b-442f-bfec-6f30721706ec.jpeg`,
      alt: 'Flot overfladestruktur på nylagt trægulv - Tømrermester Daniel Vandet',
      title: 'Smuk overfladestruktur'
    },
    {
      url: `${CDN_BASE}59f440ee-0863-4128-8f8d-1db39d7b693b.jpeg`,
      alt: 'Montering af gulv og lister i værelse - Tømrermester Daniel Vandet',
      title: 'Gulvlægning i værelse'
    },
    {
      url: `${CDN_BASE}65231299-92fe-4110-8e56-0c6747bc006b.jpeg`,
      alt: 'Gulvarbejde af høj håndværksmæssig standard - Tømrermester Daniel Vandet',
      title: 'Håndværksmæssig kvalitet'
    },
    {
      url: `${CDN_BASE}ea5e2be4-4beb-430b-93d8-2d9252bf1f9d.jpeg`,
      alt: 'Færdigt gulv i bolig med pæne overgange mellem rum - Tømrermester Daniel Vandet',
      title: 'Overgange mellem rum'
    },
    {
      url: `${CDN_BASE}fae3be24-bd3f-4fd8-b6f0-38b57c123ca8.jpeg`,
      alt: 'Nyt gulv lagt i forbindelse med ombygning - Tømrermester Daniel Vandet',
      title: 'Gulv ved ombygning'
    },
    {
      url: `${CDN_BASE}5fe9bb9d-5daa-43f6-8038-fffdd05466fd.jpeg`,
      alt: 'Lægning af gulve og montering af lofter i bolig - Tømrermester Daniel Vandet',
      title: 'Gulve og loftarbejde'
    },
    {
      url: `${CDN_BASE}e65c5d9b-2f8f-4088-af79-0f83a5487d55.jpeg`,
      alt: 'Professionel gulvlægger og tømrerarbejde på Mors - Tømrermester Daniel Vandet',
      title: 'Professionel gulvlægning'
    }
  ],

  'tagarbejde': [
    {
      url: `${CDN_BASE}9fea71e6-5eaa-45d7-ba11-c9f31e6d8d5e.jpeg`,
      alt: 'Tagrenovering og montering af nyt tag med holdbare tagsten - Tømrermester Daniel Vandet',
      title: 'Tagrenovering på Mors'
    },
    {
      url: `${CDN_BASE}89c3887e-e0e1-46e1-b569-160d84817432.jpeg`,
      alt: 'Tagarbejde med solide lægter, undertag og præcist tømrerarbejde - Tømrermester Daniel Vandet',
      title: 'Undertag og lægtning'
    },
    {
      url: `${CDN_BASE}c3589ef8-5083-425b-9f5f-2b8d7be4750e.jpeg`,
      alt: 'Lægning af tagsten og tæt afslutning af rygning - Tømrermester Daniel Vandet',
      title: 'Lægning af tagsten'
    },
    {
      url: `${CDN_BASE}c46cc554-bf56-42d4-a1a5-ee8943b4159f.jpeg`,
      alt: 'Tagkonstruktion og udskiftning af tagbelægning - Tømrermester Daniel Vandet',
      title: 'Tagkonstruktion'
    },
    {
      url: `${CDN_BASE}88edcb8e-1492-47e4-94fe-ad5648dda56a.jpeg`,
      alt: 'Professionelt tagarbejde udført på Mors - Tømrermester Daniel Vandet',
      title: 'Tagarbejde på ejendom'
    },
    {
      url: `${CDN_BASE}ee709fef-72b1-4dcf-ba4b-ebc8bdac22c8.jpeg`,
      alt: 'Nyt tag med zinkinddækninger og tagrender - Tømrermester Daniel Vandet',
      title: 'Nyt tag med zinkdetaljer'
    },
    {
      url: `${CDN_BASE}16f75c0e-0907-4da5-85b7-c8f23d406258.jpeg`,
      alt: 'Tag med metaltag/ståltag og tagrender - Tømrermester Daniel Vandet',
      title: 'Ståltag med tagrender'
    },
    {
      url: `${CDN_BASE}18c91137-47e1-44a6-875c-4c2b6e19527b.jpeg`,
      alt: 'Tagrenovering og tømrerarbejde på tagkonstruktion - Tømrermester Daniel Vandet',
      title: 'Renovering af tag'
    }
  ],

  'renovering': [
    {
      url: `${CDN_BASE}renovering-af-hus.jpg`,
      alt: 'Omfattende renovering af hus udført ind- og udvendigt - Tømrermester Daniel Vandet',
      title: 'Omfattende husrenovering'
    },
    {
      url: `${CDN_BASE}husrenovering.jpg`,
      alt: 'Totalrenovering af bolig med fokus på kvalitet og holdbarhed - Tømrermester Daniel Vandet',
      title: 'Totalrenovering af bolig'
    },
    {
      url: `${CDN_BASE}a053ad4f-39e4-443f-a801-803d1ac39583.jpeg`,
      alt: 'Ny moderne facadebeklædning i træ på hus - Tømrermester Daniel Vandet',
      title: 'Træbeklædning på facade'
    },
    {
      url: `${CDN_BASE}abd3b16e-162d-4be3-ba2b-309e0566746d.jpeg`,
      alt: 'Træbeklædning på facade monteret med ventilation - Tømrermester Daniel Vandet',
      title: 'Ventileret facadebeklædning'
    },
    {
      url: `${CDN_BASE}cf7c4e4d-833b-40ad-b76d-537e781ae106.jpeg`,
      alt: 'Facadebeklædning der fornyer husets samlede udtryk - Tømrermester Daniel Vandet',
      title: 'Moderne facadefornyelse'
    },
    {
      url: `${CDN_BASE}de26ebcf-67f5-4e09-b130-767261f7535e.jpeg`,
      alt: 'Udhæng og gavlbeklædning i vedligeholdelsesvenligt materiale - Tømrermester Daniel Vandet',
      title: 'Udhæng og gavlbeklædning'
    },
    {
      url: `${CDN_BASE}22d27ced-d99e-404b-a726-e32ba91353bd.jpeg`,
      alt: 'Gavlrenovering og nyt udhæng på bolig - Tømrermester Daniel Vandet',
      title: 'Gavlrenovering'
    },
    {
      url: `${CDN_BASE}08f97762-684b-4e16-a46a-1c5f6a5bde9c.jpeg`,
      alt: 'Nyt udhæng monteret med finish og lige linjer - Tømrermester Daniel Vandet',
      title: 'Tagudhæng og finish'
    },
    {
      url: `${CDN_BASE}d6984017-3941-4d84-bfd9-69b4fff2e1a4.jpeg`,
      alt: 'Renovering af gavl og udhæng på hus - Tømrermester Daniel Vandet',
      title: 'Renoveret gavlparti'
    },
    {
      url: `${CDN_BASE}b435369a-c996-4c03-834f-57ef4a88827a.jpeg`,
      alt: 'Gavlbeklædning udført i kvalitetsmaterialer - Tømrermester Daniel Vandet',
      title: 'Kvalitetsgavl i træ'
    },
    {
      url: `${CDN_BASE}37a84c72-69e7-4bb6-92d2-4eb516ed9eb9.jpeg`,
      alt: 'Facade- og gavlrenovering på ejendom - Tømrermester Daniel Vandet',
      title: 'Facade- og gavlarbejde'
    },
    {
      url: `${CDN_BASE}2c8bed7f-0b1c-43ab-b5a5-79114a51b482.png`,
      alt: 'Renovering af ældre ejendom med sans for detaljerne - Tømrermester Daniel Vandet',
      title: 'Renovering af ejendom'
    },
    {
      url: `${CDN_BASE}528aace0-f988-49e0-b5a8-2514079974cb.jpeg`,
      alt: 'Facade på hus moderniseret med træbeklædning - Tømrermester Daniel Vandet',
      title: 'Moderniseret husfacade'
    }
  ],

  'nybyg-og-tilbygning': [
    {
      url: `${CDN_BASE}4bfd208b-c049-43cf-9d69-ee5a8813b178.jpeg`,
      alt: 'Tilbygning til sommerhus med integreret træterrasse - Tømrermester Daniel Vandet',
      title: 'Tilbygning til sommerhus'
    },
    {
      url: `${CDN_BASE}b435369a-c996-4c03-834f-57ef4a88827a.jpeg`,
      alt: 'Nyopført gavl og tagkonstruktion ved tilbygning - Tømrermester Daniel Vandet',
      title: 'Ny gavl og tagkonstruktion'
    },
    {
      url: `${CDN_BASE}abd3b16e-162d-4be3-ba2b-309e0566746d.jpeg`,
      alt: 'Nybyggeri med moderne træbeklædning og rene linjer - Tømrermester Daniel Vandet',
      title: 'Træbeklædning på nybyg'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-trapper.jpg`,
      alt: 'Tilbygning fuldendt med integreret hævet træterrasse - Tømrermester Daniel Vandet',
      title: 'Tilbygning med terrasse'
    },
    {
      url: `${CDN_BASE}nye-terrasse-doere.jpg`,
      alt: 'Store glaspartier og terrassedøre i ny tilbygning - Tømrermester Daniel Vandet',
      title: 'Store glaspartier i tilbygning'
    },
    {
      url: `${CDN_BASE}de26ebcf-67f5-4e09-b130-767261f7535e.jpeg`,
      alt: 'Nyopført tagudhæng og gavlbeklædning - Tømrermester Daniel Vandet',
      title: 'Tagudhæng og gavl'
    },
    {
      url: `${CDN_BASE}cf7c4e4d-833b-40ad-b76d-537e781ae106.jpeg`,
      alt: 'Flot udvendig finish på nybygget boligdel - Tømrermester Daniel Vandet',
      title: 'Flot udvendig finish'
    },
    {
      url: `${CDN_BASE}c46cc554-bf56-42d4-a1a5-ee8943b4159f.jpeg`,
      alt: 'Solid spærkonstruktion og tagarbejde på tilbygning - Tømrermester Daniel Vandet',
      title: 'Spærkonstruktion på tilbygning'
    },
    {
      url: `${CDN_BASE}2077fb2c-4194-420c-afb6-801fc4f45623.jpeg`,
      alt: 'Opførelse af udhæng og gavl ved tilbygning - Tømrermester Daniel Vandet',
      title: 'Udhæng ved tilbygning'
    },
    {
      url: `${CDN_BASE}8b71dc9d-dc11-4769-8d48-94c037563730.jpeg`,
      alt: 'Tilbygningsarbejde med fokus på solidt tømrerhåndværk - Tømrermester Daniel Vandet',
      title: 'Solidt tømrerhåndværk'
    }
  ],

  'toemrerarbejde': [
    {
      url: `${CDN_BASE}ny-traeterrasse-mors.jpg`,
      alt: 'Tømrerarbejde: Opbygning af ny træterrasse på Mors - Tømrermester Daniel Vandet',
      title: 'Opbygning af ny træterrasse'
    },
    {
      url: `${CDN_BASE}udskiftning-af-vinduer-og-doere_fb146f98.jpg`,
      alt: 'Tømrerarbejde: Komplet udskiftning af vinduer og døre - Tømrermester Daniel Vandet',
      title: 'Udskiftning af vinduer og døre'
    },
    {
      url: `${CDN_BASE}opsaetning-af-nyt-hegn.jpg`,
      alt: 'Tømrerarbejde: Opsætning af hegn og stakit i haven - Tømrermester Daniel Vandet',
      title: 'Opsætning af hegn og stakit'
    },
    {
      url: `${CDN_BASE}89c3887e-e0e1-46e1-b569-160d84817432.jpeg`,
      alt: 'Tømrerarbejde: Tagrenovering og lægtning af tag - Tømrermester Daniel Vandet',
      title: 'Tagrenovering og lægtning'
    },
    {
      url: `${CDN_BASE}f826fd90-fc43-4d08-8965-f7b430dcc969.jpeg`,
      alt: 'Tømrerarbejde: Professionel lægning af nyt trægulv - Tømrermester Daniel Vandet',
      title: 'Lægning af trægulve'
    },
    {
      url: `${CDN_BASE}nyt-loft.jpg`,
      alt: 'Tømrerarbejde: Montering af nyt rustikloft i bolig - Tømrermester Daniel Vandet',
      title: 'Montering af lofter'
    },
    {
      url: `${CDN_BASE}renovering-af-hus.jpg`,
      alt: 'Tømrerarbejde: Totalrenovering og modernisering af hus - Tømrermester Daniel Vandet',
      title: 'Husrenovering og modernisering'
    },
    {
      url: `${CDN_BASE}de26ebcf-67f5-4e09-b130-767261f7535e.jpeg`,
      alt: 'Tømrerarbejde: Nyt udhæng og gavlbeklædning - Tømrermester Daniel Vandet',
      title: 'Udhæng og gavlbeklædning'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-hegn-og-trapper.jpg`,
      alt: 'Tømrerarbejde: Hævet træterrasse med gelænder og trappetrin - Tømrermester Daniel Vandet',
      title: 'Hævet terrasse med trappe'
    },
    {
      url: `${CDN_BASE}nye-sorte-vinduer.jpg`,
      alt: 'Tømrerarbejde: Montering af moderne sorte sprossevinduer - Tømrermester Daniel Vandet',
      title: 'Moderne sorte vinduer'
    }
  ],

  'om-os': [
    {
      url: `${CDN_BASE}ny-traeterrasse-mors.jpg`,
      alt: 'Referenceprojekt fra Mors: Stor specialbygget træterrasse - Tømrermester Daniel Vandet',
      title: 'Træterrasse på Mors'
    },
    {
      url: `${CDN_BASE}renovering-af-hus.jpg`,
      alt: 'Kvalitetsarbejde på Mors: Totalrenovering af bolig - Tømrermester Daniel Vandet',
      title: 'Totalrenovering af bolig'
    },
    {
      url: `${CDN_BASE}nye-terrasse-doere.jpg`,
      alt: 'Præcisionsarbejde: Nymonterede terrassedøre med flot lys - Tømrermester Daniel Vandet',
      title: 'Terrassedøre med stort lysindfald'
    },
    {
      url: `${CDN_BASE}moerk-komposithegn.jpg`,
      alt: 'Holdbare løsninger: Mørkt komposithegn opsat for kunden - Tømrermester Daniel Vandet',
      title: 'Holdbart hegn i haven'
    },
    {
      url: `${CDN_BASE}c3589ef8-5083-425b-9f5f-2b8d7be4750e.jpeg`,
      alt: 'Faglig stolthed: Nyt tag lagt med præcision - Tømrermester Daniel Vandet',
      title: 'Nyt tag lagt med præcision'
    },
    {
      url: `${CDN_BASE}8adde98a-69d4-42ac-9481-189da96e432e.jpeg`,
      alt: 'Gennemført finish: Nylagt plankegulv i stue - Tømrermester Daniel Vandet',
      title: 'Nylagt plankegulv'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-trapper.jpg`,
      alt: 'Specialbygget løsning: Hævet træterrasse med trappeovergang - Tømrermester Daniel Vandet',
      title: 'Hævet træterrasse med trappe'
    },
    {
      url: `${CDN_BASE}nyt-vindue.jpg`,
      alt: 'Kvalitetsvinduer monteret for kunde i lokalområdet - Tømrermester Daniel Vandet',
      title: 'Nyt energirigtigt vindue'
    }
  ],

  'referencer': [
    {
      url: `${CDN_BASE}ny-traeterrasse-mors.jpg`,
      alt: 'Opbygning af ny stor træterrasse på Mors - Tømrermester Daniel Vandet',
      category: 'Træterrasse',
      title: 'Ny træterrasse på Mors'
    },
    {
      url: `${CDN_BASE}nye-terrasse-doere.jpg`,
      alt: 'Montering af nye terrassedøre med store glaspartier - Tømrermester Daniel Vandet',
      category: 'Døre og vinduer',
      title: 'Nye terrassedøre'
    },
    {
      url: `${CDN_BASE}renovering-af-hus.jpg`,
      alt: 'Totalrenovering af bolig indvendigt og udvendigt - Tømrermester Daniel Vandet',
      category: 'Renovering',
      title: 'Omfattende husrenovering'
    },
    {
      url: `${CDN_BASE}opsaetning-af-nyt-hegn.jpg`,
      alt: 'Opsætning af nyt læhegn i træ i haven - Tømrermester Daniel Vandet',
      category: 'Hegn og stakit',
      title: 'Nyt læhegn i træ'
    },
    {
      url: `${CDN_BASE}89c3887e-e0e1-46e1-b569-160d84817432.jpeg`,
      alt: 'Tagarbejde med solide lægter og undertag - Tømrermester Daniel Vandet',
      category: 'Tagarbejde',
      title: 'Undertag og lægtning'
    },
    {
      url: `${CDN_BASE}f826fd90-fc43-4d08-8965-f7b430dcc969.jpeg`,
      alt: 'Lægning af nyt trægulv med præcise samlinger - Tømrermester Daniel Vandet',
      category: 'Gulve',
      title: 'Lægning af nyt trægulv'
    },
    {
      url: `${CDN_BASE}nyt-loft.jpg`,
      alt: 'Montering af nyt rustikloft / træloft - Tømrermester Daniel Vandet',
      category: 'Lofter',
      title: 'Montering af nyt loft'
    },
    {
      url: `${CDN_BASE}haevet-traeterrasse-med-hegn-og-trapper.jpg`,
      alt: 'Hævet terrasse med indbygget gelænder, hegn og trappetrin - Tømrermester Daniel Vandet',
      category: 'Træterrasse',
      title: 'Hævet terrasse med hegn og trappe'
    },
    {
      url: `${CDN_BASE}udskiftning-af-vinduer-og-doere_fb146f98.jpg`,
      alt: 'Komplet udskiftning af vinduer og døre i bolig på Mors - Tømrermester Daniel Vandet',
      category: 'Døre og vinduer',
      title: 'Udskiftning af vinduer og døre'
    },
    {
      url: `${CDN_BASE}moerk-komposithegn.jpg`,
      alt: 'Mørkt komposithegn eller plankeværk opsat for optimalt privatliv - Tømrermester Daniel Vandet',
      category: 'Hegn og stakit',
      title: 'Mørkt hegn'
    },
    {
      url: `${CDN_BASE}de26ebcf-67f5-4e09-b130-767261f7535e.jpeg`,
      alt: 'Udhæng og gavlbeklædning i vedligeholdelsesvenligt materiale - Tømrermester Daniel Vandet',
      category: 'Udhæng og gavlbeklædning',
      title: 'Udhæng og gavlbeklædning'
    },
    {
      url: `${CDN_BASE}nye-sorte-vinduer.jpg`,
      alt: 'Nye moderne sorte vinduer monteret med præcise fuger - Tømrermester Daniel Vandet',
      category: 'Døre og vinduer',
      title: 'Moderne sorte vinduer'
    },
    {
      url: `${CDN_BASE}c3589ef8-5083-425b-9f5f-2b8d7be4750e.jpeg`,
      alt: 'Lægning af tagsten og afslutning af rygning - Tømrermester Daniel Vandet',
      category: 'Tagarbejde',
      title: 'Tagsten og rygning'
    },
    {
      url: `${CDN_BASE}husrenovering.jpg`,
      alt: 'Renovering af parcelhus med sans for detaljen - Tømrermester Daniel Vandet',
      category: 'Renovering',
      title: 'Parcelhusrenovering'
    },
    {
      url: `${CDN_BASE}traeterrasse-til-sommerhus.jpg`,
      alt: 'Træterrasse opført til sommerhus i rolige omgivelser - Tømrermester Daniel Vandet',
      category: 'Træterrasse',
      title: 'Sommerhusterrasse'
    },
    {
      url: `${CDN_BASE}ny-hvid-doer.jpg`,
      alt: 'Ny hvid facadedør med sprosser monteret i murstenshus - Tømrermester Daniel Vandet',
      category: 'Døre og vinduer',
      title: 'Hvid facadedør'
    }
  ]
}

// Fuld liste over alle referencebilleder med kategorier (bruges til filtrerbart galleri på /referencer)
export const ALL_REFERENCE_IMAGES = [
  ...GALLERY_BY_KEY['vinduer-og-doere'].map(img => ({ ...img, category: 'Døre og vinduer' })),
  ...GALLERY_BY_KEY['traeterasse'].map(img => ({ ...img, category: 'Træterrasse' })),
  ...GALLERY_BY_KEY['hegn-og-stakit'].map(img => ({ ...img, category: 'Hegn og stakit' })),
  ...GALLERY_BY_KEY['gulve-og-lofte'].map(img => ({ ...img, category: 'Gulve og lofter' })),
  ...GALLERY_BY_KEY['tagarbejde'].map(img => ({ ...img, category: 'Tagarbejde' })),
  ...GALLERY_BY_KEY['renovering'].map(img => ({ ...img, category: 'Renovering' }))
]

// Unikke kategorier til filterknapper
export const ALL_CATEGORIES = [
  'Alle',
  'Døre og vinduer',
  'Træterrasse',
  'Hegn og stakit',
  'Gulve og lofter',
  'Tagarbejde',
  'Renovering'
]
